<div class="text-block-wrapper" *ngIf="!isLoading">
  <div
    *ngIf="titleContent"
    class="text-block"
    [ngClass]="{
      'text-block--left': titleAlign === TextBlockAlign.LEFT,
    }"
  >
    <ng-container>
      <ng-container [ngSwitch]="titleVariant">
        <h1 *ngSwitchCase="TextBlockTitleVariant.H1">
          {{ titleContent.trim() }}
        </h1>
        <h2 *ngSwitchCase="TextBlockTitleVariant.H2">
          {{ titleContent.trim() }}
        </h2>
      </ng-container>
    </ng-container>
  </div>
  <ng-container
    *ngIf="
      paragraph &&
      caasData?.formData?.st_text_columns?.value?.identifier !== '2-manual'
    "
  >
    <div
      [class]="
        'text-block ' +
        (caasData?.formData?.st_text_columns?.value?.identifier || '')
      "
      [ngClass]="{
        'text-block--left': paragraphAlign === TextBlockAlign.LEFT,
      }"
      [innerHtml]="paragraph"
    ></div>
  </ng-container>
  <div
    *ngIf="
      caasData?.formData?.st_text_columns?.value?.identifier === '2-manual'
    "
    class="text-block columns-manual"
  >
    <div
      class="column"
      *ngIf="caasData?.formData?.st_bodytext?.value"
      [innerHtml]="caasData?.formData?.st_bodytext?.value"
    ></div>
    <div
      class="column"
      *ngIf="caasData?.formData?.st_bodytext_2?.value"
      [innerHtml]="caasData?.formData?.st_bodytext_2?.value"
    ></div>
  </div>
</div>
